import Promise from 'promise-polyfill'

export default window =>
  new Promise(resolve => {
    if (window.document.readyState !== 'loading') {
      return resolve(window.document.readyState)
    }

    const readyStateChangeHandler = () => {
      if (window.document.readyState === 'loading') {
        return
      }

      window.document.removeEventListener('readystatechange', readyStateChangeHandler)
      resolve(window.document.readyState)
    }

    window.document.addEventListener('readystatechange', readyStateChangeHandler)
  })
